import { Dialog as PrimitiveDialog } from "@ark-ui/react";
import Content from "./Content/Content";
import Title from "./Title/Title";
import Description from "./Description/Description";
import Trigger from "./Trigger/Trigger";
import type { ComponentProps } from "react";
import CloseTrigger from "./Trigger/CloseTrigger";

type CustomProps = {
  onClose?: () => void;
};

type Props = Omit<ComponentProps<typeof PrimitiveDialog.Root>, keyof CustomProps> & CustomProps;

const DialogRoot = ({ open, onClose, children, ...rest }: Props) => {
  return (
    <PrimitiveDialog.Root open={open} onOpenChange={(dialog) => !dialog.open && onClose?.()} {...rest}>
      {children}
    </PrimitiveDialog.Root>
  );
};

export const Dialog = Object.assign(DialogRoot, {
  Trigger,
  Content,
  Title,
  Description,
  CloseTrigger,
});
